import { useContext } from 'react'

import { EpostFormContext } from '../../EpostForm'

export function useEpostFormContext() {
  return useContext(EpostFormContext)
}
